import { useEffect, useState } from "react"
import { StepWizard, Wizard } from "../../../../bpm/config/Componentes/wizard/Wizard";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _CashRequest } from "../../../../../core/services/dataBean/EntityCatalog";
import { CreateRequestCash } from "./CreateRequestCash";
import { CreateRequestCashItems } from "./CreateRequestCashItems";
import { toast } from "react-toastify";
import { PrintJson } from "../../../../theme/Component/PrintJson";

interface MapProperties {
    FormData: Record<string, any>;
    ObjectList: object[];
    DocumentList: Record<string, any>;
}

interface Props {
    onChange: Function;
}

export const RequestCashReimbursement = ({ onChange }: Props) => {

    const { instance } = useDataBean(_CashRequest);

    const [canDiscard, setCanDiscard] = useState<boolean>(false);
    const [map, setMap] = useState<MapProperties>({
        FormData: {},
        ObjectList: [],
        DocumentList: {}
    });


    const validarContrato = () => {
        console.log("Se Ejecuta")
        updateItem();
    }

    useEffect(() => {
        if (map.DocumentList.MSGList?.length > 0) {
            setCanDiscard(true)
        } else {
            setCanDiscard(false)
        }
    }, [map.DocumentList])

    const updateItem = () => {
        let data = map.FormData
        instance.updateCashRequest(map.FormData).then(
            (resp) => {
                data.ResponseService = resp;
                setMap({ ...map, FormData: data });
            }
        ).catch(
            err => {
                console.error(err);
            }
        )
    }

    const steps: StepWizard[] = [
        {
            keyID: "0",
            name: 'PASO 1. Crear una Solicitud',
            onEvent: validarContrato,
            children: <CreateRequestCash onChange={(e) => { setMap({ ...map, "FormData": e }) }} />,
            validButton: (map.FormData.CashRequestDate && map.FormData.Description),
            canReturn: false
        },
        {
            keyID: "1",
            name: 'PASO 2. Facturas a Rembolsar',
            onEvent: () => {
                if (onChange) {
                    onChange()
                }
            },
            children: <CreateRequestCashItems response={map.FormData.ResponseService} formData={map.FormData} onChange={(e) => { setMap({ ...map, "ObjectList": e }) }} />,
            validButton: (map.ObjectList.length > 0),
            canReturn: true
        },
    ]

    return (
        <>
            <Wizard title="Certificado Disponibilidad Presupuestal" listStep={steps} />
        </>
    )
}